import { buzzList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function BuzzSection() {
  return (
    <section id="buzz" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading eyebrow="热议大瓜盘点" title="大瓜现场 · 这一周大家都在吃" sub="热度最高的热议大瓜与焦点话题现场盘点，配图仅为氛围示意，内容以官方与多方公开信息为准。" />
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-bold text-foreground-600 whitespace-nowrap">
            <i className="ri-refresh-line text-accent-600"></i>
            过去 24 小时热门盘点
          </span>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {buzzList.map((b) => (
            <article
              key={b.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative overflow-hidden bg-background-100">
                <img src={b.img} alt={b.title} className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-accent-950/90 px-2 py-1 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill text-primary-400"></i>
                  {b.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="line-clamp-2 font-heading text-lg font-bold leading-snug text-foreground-950">{b.title}</h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-700">{b.excerpt}</p>
                <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3.5 text-xs text-foreground-600">
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line text-primary-600"></i>{b.comments}</span>
                  <span className="flex items-center gap-1"><i className="ri-thumb-up-line text-accent-600"></i>{b.likes}</span>
                  <span className="ml-auto flex items-center gap-1"><i className="ri-time-line"></i>{b.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            type="button"
            onClick={() => document.getElementById("deep")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center gap-2 rounded-md border border-accent-300 bg-background-50 px-5 py-2.5 text-sm font-bold whitespace-nowrap text-accent-800 transition-colors hover:bg-accent-100"
          >
            还想看更深的分析？
            <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}